import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiAdminV1OrganizationList: build.query<
      ApiAdminV1OrganizationListApiResponse,
      ApiAdminV1OrganizationListApiArg
    >({
      query: () => ({ url: `/api/admin/v1/organization/` }),
    }),
    apiAdminV1OrganizationCreate: build.mutation<
      ApiAdminV1OrganizationCreateApiResponse,
      ApiAdminV1OrganizationCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization/`,
        method: "POST",
        body: queryArg.organization,
      }),
    }),
    apiAdminV1OrganizationRecordValuesList: build.query<
      ApiAdminV1OrganizationRecordValuesListApiResponse,
      ApiAdminV1OrganizationRecordValuesListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-record-values/`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    apiAdminV1OrganizationRecordValuesCreate: build.mutation<
      ApiAdminV1OrganizationRecordValuesCreateApiResponse,
      ApiAdminV1OrganizationRecordValuesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-record-values/`,
        method: "POST",
        body: queryArg.organizationRecordValueCreateUpdate,
      }),
    }),
    apiAdminV1OrganizationRecordValuesRetrieve: build.query<
      ApiAdminV1OrganizationRecordValuesRetrieveApiResponse,
      ApiAdminV1OrganizationRecordValuesRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-record-values/${queryArg.id}/`,
      }),
    }),
    apiAdminV1OrganizationRecordValuesUpdate: build.mutation<
      ApiAdminV1OrganizationRecordValuesUpdateApiResponse,
      ApiAdminV1OrganizationRecordValuesUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-record-values/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.organizationRecordValueCreateUpdate,
      }),
    }),
    apiAdminV1OrganizationRecordValuesDestroy: build.mutation<
      ApiAdminV1OrganizationRecordValuesDestroyApiResponse,
      ApiAdminV1OrganizationRecordValuesDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-record-values/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    apiAdminV1OrganizationRecordsList: build.query<
      ApiAdminV1OrganizationRecordsListApiResponse,
      ApiAdminV1OrganizationRecordsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-records/`,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
          organization_id: queryArg.organizationId,
          search: queryArg.search,
        },
      }),
    }),
    apiAdminV1OrganizationRecordsCreate: build.mutation<
      ApiAdminV1OrganizationRecordsCreateApiResponse,
      ApiAdminV1OrganizationRecordsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-records/`,
        method: "POST",
        body: queryArg.organizationRecordCreateUpdate,
      }),
    }),
    apiAdminV1OrganizationRecordsRetrieve: build.query<
      ApiAdminV1OrganizationRecordsRetrieveApiResponse,
      ApiAdminV1OrganizationRecordsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-records/${queryArg.id}/`,
      }),
    }),
    apiAdminV1OrganizationRecordsUpdate: build.mutation<
      ApiAdminV1OrganizationRecordsUpdateApiResponse,
      ApiAdminV1OrganizationRecordsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-records/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.organizationRecordCreateUpdate,
      }),
    }),
    apiAdminV1OrganizationRecordsDestroy: build.mutation<
      ApiAdminV1OrganizationRecordsDestroyApiResponse,
      ApiAdminV1OrganizationRecordsDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-records/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    apiAdminV1OrganizationRetrieve: build.query<
      ApiAdminV1OrganizationRetrieveApiResponse,
      ApiAdminV1OrganizationRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization/${queryArg.id}/`,
      }),
    }),
    apiAdminV1OrganizationUpdate: build.mutation<
      ApiAdminV1OrganizationUpdateApiResponse,
      ApiAdminV1OrganizationUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.organization,
      }),
    }),
    apiAdminV1OrganizationPartialUpdate: build.mutation<
      ApiAdminV1OrganizationPartialUpdateApiResponse,
      ApiAdminV1OrganizationPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedOrganization,
      }),
    }),
    apiAdminV1OrganizationDestroy: build.mutation<
      ApiAdminV1OrganizationDestroyApiResponse,
      ApiAdminV1OrganizationDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    apiAdminV1OrganizationCloneCreate: build.mutation<
      ApiAdminV1OrganizationCloneCreateApiResponse,
      ApiAdminV1OrganizationCloneCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization/clone/`,
        method: "POST",
        body: queryArg.organization,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as adminApi };
export type ApiAdminV1OrganizationListApiResponse =
  /** status 200  */ OrganizationRead[];
export type ApiAdminV1OrganizationListApiArg = void;
export type ApiAdminV1OrganizationCreateApiResponse =
  /** status 200  */ OrganizationRead;
export type ApiAdminV1OrganizationCreateApiArg = {
  organization: Organization;
};
export type ApiAdminV1OrganizationRecordValuesListApiResponse =
  /** status 200  */ OrganizationRecordValueRead[];
export type ApiAdminV1OrganizationRecordValuesListApiArg = {
  /** ID of the organization */
  organizationId?: number;
};
export type ApiAdminV1OrganizationRecordValuesCreateApiResponse =
  /** status 201  */ OrganizationRecordValueRead;
export type ApiAdminV1OrganizationRecordValuesCreateApiArg = {
  organizationRecordValueCreateUpdate: OrganizationRecordValueCreateUpdate;
};
export type ApiAdminV1OrganizationRecordValuesRetrieveApiResponse =
  /** status 200  */ OrganizationRecordValueRead;
export type ApiAdminV1OrganizationRecordValuesRetrieveApiArg = {
  /** A unique integer value identifying this organization record value. */
  id: number;
};
export type ApiAdminV1OrganizationRecordValuesUpdateApiResponse =
  /** status 200  */ OrganizationRecordValueRead;
export type ApiAdminV1OrganizationRecordValuesUpdateApiArg = {
  /** A unique integer value identifying this organization record value. */
  id: number;
  organizationRecordValueCreateUpdate: OrganizationRecordValueCreateUpdate;
};
export type ApiAdminV1OrganizationRecordValuesDestroyApiResponse = unknown;
export type ApiAdminV1OrganizationRecordValuesDestroyApiArg = {
  /** A unique integer value identifying this organization record value. */
  id: number;
};
export type ApiAdminV1OrganizationRecordsListApiResponse =
  /** status 200  */ OrganizationRecordRead[];
export type ApiAdminV1OrganizationRecordsListApiArg = {
  /** ID of the assessment period */
  assessmentPeriodId?: number;
  /** ID of the organization */
  organizationId?: number;
  /** Search term for value */
  search?: string;
};
export type ApiAdminV1OrganizationRecordsCreateApiResponse =
  /** status 201  */ OrganizationRecordRead;
export type ApiAdminV1OrganizationRecordsCreateApiArg = {
  organizationRecordCreateUpdate: OrganizationRecordCreateUpdate;
};
export type ApiAdminV1OrganizationRecordsRetrieveApiResponse =
  /** status 200  */ OrganizationRecordRead;
export type ApiAdminV1OrganizationRecordsRetrieveApiArg = {
  /** A unique integer value identifying this organization record. */
  id: number;
};
export type ApiAdminV1OrganizationRecordsUpdateApiResponse =
  /** status 200  */ OrganizationRecordRead;
export type ApiAdminV1OrganizationRecordsUpdateApiArg = {
  /** A unique integer value identifying this organization record. */
  id: number;
  organizationRecordCreateUpdate: OrganizationRecordCreateUpdate;
};
export type ApiAdminV1OrganizationRecordsDestroyApiResponse = unknown;
export type ApiAdminV1OrganizationRecordsDestroyApiArg = {
  /** A unique integer value identifying this organization record. */
  id: number;
};
export type ApiAdminV1OrganizationRetrieveApiResponse =
  /** status 200  */ OrganizationRead;
export type ApiAdminV1OrganizationRetrieveApiArg = {
  /** A unique integer value identifying this organization. */
  id: number;
};
export type ApiAdminV1OrganizationUpdateApiResponse =
  /** status 200  */ OrganizationRead;
export type ApiAdminV1OrganizationUpdateApiArg = {
  /** A unique integer value identifying this organization. */
  id: number;
  organization: Organization;
};
export type ApiAdminV1OrganizationPartialUpdateApiResponse =
  /** status 200  */ OrganizationRead;
export type ApiAdminV1OrganizationPartialUpdateApiArg = {
  /** A unique integer value identifying this organization. */
  id: number;
  patchedOrganization: PatchedOrganization;
};
export type ApiAdminV1OrganizationDestroyApiResponse = unknown;
export type ApiAdminV1OrganizationDestroyApiArg = {
  /** A unique integer value identifying this organization. */
  id: number;
};
export type ApiAdminV1OrganizationCloneCreateApiResponse =
  /** status 200  */ OrganizationRead;
export type ApiAdminV1OrganizationCloneCreateApiArg = {
  organization: Organization;
};
export type TierEnum = 1 | 2 | 3 | 4;
export type OrganizationOption = {
  key: string;
  name?: string | null;
  enabled?: boolean;
  config?: any;
};
export type Organization = {
  name?: string | null;
  time_zone?: string | null;
  is_archived?: boolean;
  tier?: TierEnum;
  categories?: any | null;
  default_survey_question?: number | null;
  default_outcome_question?: number | null;
  default_min_followup?: number;
  default_max_followup?: number;
  /** Default cron expression for reminder emails (Mon/Wed/Fri at 9am UTC) */
  default_reminder_schedule?: string | null;
  organization_options?: OrganizationOption[];
};
export type OrganizationRead = {
  id: number;
  name?: string | null;
  time_zone?: string | null;
  is_archived?: boolean;
  tier?: TierEnum;
  categories?: any | null;
  default_survey_question?: number | null;
  default_outcome_question?: number | null;
  default_min_followup?: number;
  default_max_followup?: number;
  /** Default cron expression for reminder emails (Mon/Wed/Fri at 9am UTC) */
  default_reminder_schedule?: string | null;
  organization_options?: OrganizationOption[];
};
export type OrganizationRecordValue = {
  id: number;
  name: string;
  type_of_value: number;
  sort_order: number;
  max_range: number;
  min_range: number;
  created_at: string;
};
export type OrganizationRecordValueRead = {
  id: number;
  name: string;
  type_of_value: number;
  sort_order: number;
  max_range: number;
  min_range: number;
  organization: string;
  created_at: string;
};
export type OrganizationRecordValueCreateUpdateTypeOfValueEnum = 1 | 2 | 3 | 4;
export type OrganizationRecordValueCreateUpdate = {
  id?: number;
  name: string;
  type_of_value: OrganizationRecordValueCreateUpdateTypeOfValueEnum;
  sort_order?: number;
  max_range?: number;
  min_range?: number;
  organization: number;
};
export type OrganizationRecord = {
  value: string;
};
export type OrganizationRecordRead = {
  id: number;
  organization: string;
  organization_record_value: string;
  value: string;
  assessment_period: string;
  created_at: string;
  updated_at: string;
};
export type OrganizationRecordCreateUpdate = {
  id?: number;
  organization: number;
  organization_record_value: number;
  value?: string;
  assessment_period?: number | null;
};
export type PatchedOrganization = {
  name?: string | null;
  time_zone?: string | null;
  is_archived?: boolean;
  tier?: TierEnum;
  categories?: any | null;
  default_survey_question?: number | null;
  default_outcome_question?: number | null;
  default_min_followup?: number;
  default_max_followup?: number;
  /** Default cron expression for reminder emails (Mon/Wed/Fri at 9am UTC) */
  default_reminder_schedule?: string | null;
  organization_options?: OrganizationOption[];
};
export type PatchedOrganizationRead = {
  id?: number;
  name?: string | null;
  time_zone?: string | null;
  is_archived?: boolean;
  tier?: TierEnum;
  categories?: any | null;
  default_survey_question?: number | null;
  default_outcome_question?: number | null;
  default_min_followup?: number;
  default_max_followup?: number;
  /** Default cron expression for reminder emails (Mon/Wed/Fri at 9am UTC) */
  default_reminder_schedule?: string | null;
  organization_options?: OrganizationOption[];
};
export const {
  useApiAdminV1OrganizationListQuery,
  useApiAdminV1OrganizationCreateMutation,
  useApiAdminV1OrganizationRecordValuesListQuery,
  useApiAdminV1OrganizationRecordValuesCreateMutation,
  useApiAdminV1OrganizationRecordValuesRetrieveQuery,
  useApiAdminV1OrganizationRecordValuesUpdateMutation,
  useApiAdminV1OrganizationRecordValuesDestroyMutation,
  useApiAdminV1OrganizationRecordsListQuery,
  useApiAdminV1OrganizationRecordsCreateMutation,
  useApiAdminV1OrganizationRecordsRetrieveQuery,
  useApiAdminV1OrganizationRecordsUpdateMutation,
  useApiAdminV1OrganizationRecordsDestroyMutation,
  useApiAdminV1OrganizationRetrieveQuery,
  useApiAdminV1OrganizationUpdateMutation,
  useApiAdminV1OrganizationPartialUpdateMutation,
  useApiAdminV1OrganizationDestroyMutation,
  useApiAdminV1OrganizationCloneCreateMutation,
} = injectedRtkApi;
